import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import DevelopmentActions from "data/dev/DevelopmentActions";
import typeCheckingStore from "data/util/typeCheckingStore";

class MocksetStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return {};
    }

    reduce(state, action) {
        switch (action.type) {
            case DevelopmentActions.SELECT_MOCKSET:
                return {
                    mockset: action.mockset,
                };
            default:
                return state;
        }
    }

}

MocksetStore.stateTypes = {
    mockset: PropTypes.string,
};

export default typeCheckingStore(new MocksetStore());



// WEBPACK FOOTER //
// ./app/data/dev/MocksetStore.js